export const VALIDATE_FORMULA_AFTER_MS = 600
